import { render } from "./ContentTranslationForm.vue?vue&type=template&id=b7a9438e"
import script from "./ContentTranslationForm.vue?vue&type=script&lang=js"
export * from "./ContentTranslationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__